"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComputedObservable = void 0;
var Observable_1 = require("./Observable");
var ComputedObservable = /** @class */ (function () {
    function ComputedObservable(func, subscribables, equalityComparer) {
        var _this = this;
        var handler = function () {
            _this._observable.value = func();
        };
        this._handler = handler;
        this._observable = new Observable_1.Observable(func(), equalityComparer);
        this._subscriptions = subscribables.map(function (s) { return s.subscribe(_this._handler); });
        this._handler();
    }
    Object.defineProperty(ComputedObservable.prototype, "value", {
        get: function () {
            return this._observable.value;
        },
        enumerable: false,
        configurable: true
    });
    ComputedObservable.prototype.subscribe = function (handler) {
        return this._observable.subscribe(handler);
    };
    ComputedObservable.prototype.dispose = function () {
        this._subscriptions.forEach(function (s) { return s.dispose(); });
        this._observable.dispose();
    };
    return ComputedObservable;
}());
exports.ComputedObservable = ComputedObservable;
//# sourceMappingURL=ComputedObservable.js.map